export const HttpStatusCode = {
  OK: 200,
  Created: 201,
  MultipleChoices: 300,
  BadRequest: 400,
  Unauthorized: 401,
  NotFound: 404,
  Conflict: 409,
  InternalServerError: 500,
  UnprocessableEntity: 422,
  TimeOut: 524,
};

export const ErrorMessage = {
  Default: 'Error while processing. Please try again.',
  [HttpStatusCode.NotFound]:
    '[404] This is not the web page you are looking for.',
  [HttpStatusCode.InternalServerError]:
    '[500] Sorry, something went wrong. Please try again, or refresh the page.',
  ParsingFailed: 'Error while parsing.',
  TokenExpired: 'Token has been expired.',
};

export const REGEXP_RFC = new RegExp(
  /^([A-ZÑ&]{3,4}) ?(?:- ?)?(\d{2}(?:0[1-9]|1[0-2])(?:0[1-9]|[12]\d|3[01])) ?(?:- ?)?([A-Z\d]{2})([A\d])$/,
);

export const REGEXP_AMIB = new RegExp(/^[a-z0-9]+$/i);

export const RFC_PATTERN =
  '^([A-ZÑ&]{3,4}) ?(?:- ?)?(d{2}(?:0[1-9]|1[0-2])(?:0[1-9]|[12]d|3[01])) ?(?:- ?)?([A-Zd]{2})([Ad])$';

export const REGEXP_CURP = new RegExp(
  /^[A-Z]{1}[AEIOUX]{1}[A-Z]{2}[0-9]{2}(0[1-9]|1[0-2])(0[1-9]|1[0-9]|2[0-9]|3[0-1])[HM]{1}(AS|BC|BS|CC|CS|CH|CL|CM|DF|DG|GT|GR|HG|JC|MC|MN|MS|NT|NL|OC|PL|QT|QR|SP|SL|SR|TC|TS|TL|VZ|YN|ZS|NE)[B-DF-HJ-NP-TV-Z]{3}[0-9A-Z]{1}[0-9]{1}$/,
);

export const REGEXP_CP = new RegExp(/^\d{5}$/);

export const REGEXP_TEXT = new RegExp(/([a-zA-Záéíóúü])+/);

export const REGEXP_URL = new RegExp(
  /[(http(s)?)://(www.)?a-zA-Z0-9@:%._+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_+.~#?&//=]*)/gi,
);

export const REGEXP_DATE = new RegExp(
  /^(19[0-9]{2}|2[0-9]{3})\/(0[1-9]|1[012])\/([123]0|[012][1-9]|31)$/,
);

export const debounceTime = 300;

export const MarketType = {
  fixedIncome: 'RF',
  variableIncome: 'RV',
};

export const clientRoles = {
  CLIENT: 'CL',
  CO_OWNER: 'CO',
  BENEFICIARY: 'BE',
};

export const PERSON_TYPE = {
  moral: '2',
  fisica: '1',
  fideicomiso: '3',
};

export const ACTIVE_STATUS_ACCOUNTS = '1';
export const ACTIVE_STATUS = '1';

export const CLIENTS_URL = {
  coOwnersBack: '',
};

export const NO_RESULT_FILTERS =
  'No se encontraron coincidencias con los filtros seleccionados';

export const QUERY_STALE_TIME_DEFAULT = 1000 * 60 * 60;

export const FORMAT_DATE_DEFAULT = 'YYYY-MM-DD';

export const HEADER_FILE_NAME = 'file_name';

export const LOAD_LAYOUTS = {
  MOVIMIENTOS: 1001,
  POSICIONES: 1002,
  SALDOS: 1003,
};

export const KEYCLOAK_ROLES = {
  socio: 'SOCIO',
  banquero: 'BANQUERO',
  operaciones: 'OPERACIONES',
  administracionApertura: 'ADMINISTRACION_APERTURA',
  compliancePld: 'COMPLIANCE_PLD',
  compliancePracticaVenta: 'COMPLIANCE_PRACTICA_VENTA',
  adminUsers: 'ADMIN_USUARIOS',
  complianceOfficer: 'OFICIAL_CUMPLIMIENTO',
  commissionsAndIncentives: 'COMISIONES_INCENTIVOS',
  cliente: 'CLIENTE',
  superAdmin: 'SA',
  consulta: 'CONSULTA',
};

export const OTHER_KEYCLOAK_ROLES = {
  specialOperations: 'OPERACIONES_ESPECIALES',
};

export const SYSTEM_ROLES = {
  socio: 'socio',
  banquero: 'banquero',
  operaciones: 'operaciones',
  apertura: 'apertura',
  pld: 'pld',
  venta: 'venta',
  adminUsers: 'admin_usuarios',
  complianceOfficer: 'oficial_cumplimiento',
  commissionsAndIncentives: 'comisiones_incentivos',
  cliente: 'cliente',
  consulta: 'consulta',
  otro: 'otro',
};

export const ROLE_MAPPING = new Map([
  [KEYCLOAK_ROLES.socio, SYSTEM_ROLES.socio],
  [KEYCLOAK_ROLES.banquero, SYSTEM_ROLES.banquero],
  [KEYCLOAK_ROLES.operaciones, SYSTEM_ROLES.operaciones],
  [KEYCLOAK_ROLES.administracionApertura, SYSTEM_ROLES.apertura],
  [KEYCLOAK_ROLES.compliancePld, SYSTEM_ROLES.pld],
  [KEYCLOAK_ROLES.compliancePracticaVenta, SYSTEM_ROLES.venta],
  [KEYCLOAK_ROLES.adminUsers, SYSTEM_ROLES.adminUsers],
  [KEYCLOAK_ROLES.complianceOfficer, SYSTEM_ROLES.complianceOfficer],
  [KEYCLOAK_ROLES.cliente, SYSTEM_ROLES.cliente],
  [
    KEYCLOAK_ROLES.commissionsAndIncentives,
    SYSTEM_ROLES.commissionsAndIncentives,
  ],
  [KEYCLOAK_ROLES.consulta, SYSTEM_ROLES.consulta],
]);

export const INVESTMENT_OFFICES = {
  SURA: 'SURA',
  SMART_CAPITAL: 'SMART_CAPITAL',
  DMOS: 'DMOS',
  INCO: 'INCO',
} as const;

export const SuraBrokerageHouseId = {
  BBVA: '19',
  GNP: '23',
  ALLIANZ: '24',
} as const;

export const cronLocaleES = {
  everyText: 'Cada',
  emptyMonths: 'cada mes',
  emptyMonthDays: 'cada día del mes',
  emptyWeekDays: 'cada día de la semana',
  emptyHours: 'cada hora',
  emptyMinutes: 'cada minuto',
  emptySeconds: 'cada segundo',
  yearOption: 'año',
  monthOption: 'mes',
  weekOption: 'semana',
  dayOption: 'día',
  hourOption: 'hora',
  minuteOption: 'minuto',
  secondOption: 'segundo',
  rebootOption: 'reiniciar',
  prefixPeriod: 'Cada',
  prefixMonths: 'en',
  prefixMonthDays: 'el',
  prefixWeekDays: 'el',
  prefixHours: 'a las',
  prefixMinutes: 'a los',
  prefixSeconds: 'a los',
  suffixMinutesForHourPeriod: 'minutos',
  errorInvalidCron: 'Expresión cron inválida',
  clearButtonText: 'Limpiar',
  and: 'y',
  weekDays: [
    'Domingo',
    'Lunes',
    'Martes',
    'Miércoles',
    'Jueves',
    'Viernes',
    'Sábado',
  ],
  months: [
    'Enero',
    'Febrero',
    'Marzo',
    'Abril',
    'Mayo',
    'Junio',
    'Julio',
    'Agosto',
    'Septiembre',
    'Octubre',
    'Noviembre',
    'Diciembre',
  ],
  altWeekDays: ['Dom', 'Lun', 'Mar', 'Mié', 'Jue', 'Vie', 'Sáb'],
  altMonths: [
    'Ene',
    'Feb',
    'Mar',
    'Abr',
    'May',
    'Jun',
    'Jul',
    'Ago',
    'Sep',
    'Oct',
    'Nov',
    'Dic',
  ],
};
